<script>
import pell from 'pell';

export default {
  name: 'RbxTextEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default() {
        return [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'heading1',
          'heading2',
          'paragraph',
          'quote',
          'olist',
          'ulist',
          'code',
          'line',
          'link',
        ];
      },
    },
  },
  data() {
    return {
      editor: null,
      html: '',
    };
  },
  watch: {
    value(newValue) {
      if (this.html !== newValue) {
        this.editor.content.innerHTML = this.value;
      }
    },
  },
  mounted() {
    this.editor = pell.init({
      element: this.$refs.editor,
      onChange: this.onChange,
      defaultParagraphSeparator: 'div',
      actions: this.actions,
      styleWithCSS: false,
    });

    this.editor.content.innerHTML = this.value;
  },
  methods: {
    onChange(html) {
      this.html = html;
      this.$emit('input', html);
    },
  },
};
</script>

<template>
  <div class="rbx-text-editor">
    <div class="rbx-text-editor-title">{{ label }}</div>
    <div ref="editor" class="rbx-text-editor-content" />
  </div>
</template>

<style lang="scss">
.rbx-text-editor {
  &-title:not(:empty) {
    margin-bottom: 5px;
    color: rgba(0, 0, 0, 0.54);
    font-size: 12px;
  }

  &-content {
    overflow: auto;
    border: 1px solid rgba(10, 10, 10, 0.1);
    border-radius: 7px;
    height: 120px;
  }
}
</style>
